import { NgModule } from '@angular/core';
import { GtmGgCartAddEntrySuccessEventBuilder } from './gtm-gg-cart-add-entry-success-event.builder';

@NgModule({})
export class GtmGgCartAddEntrySuccessEventModule {
  constructor(_gtmGgCartAddEntrySuccessEventBuilder: GtmGgCartAddEntrySuccessEventBuilder) {}
}
